
import { withStyles } from "@material-ui/core/styles";


import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
const styles = {
  paperRoot: {
    boxShadow:
      "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23) !important",
    borderRadius: "15px !important",
  },
  MuiTypographyRoot: {
    fontFamily: "Inter !important",
    fontWeight: "700 !important",
    fontSize: "16px !important",
    lineHeight: "27px !important",
    letterSpacing: "0 !important",
    marginBottom: "0 !important",
  },
};

const CardComponent = ({ classes, ...props }) => {
  return (
    <Card
      classes={{ root: classes.paperRoot }}
      sx={{ maxWidth: "100%" }}
      className="Card"
    >
      <CardMedia
        component="img"
        height="400"
        image={props.image}
        alt={props.alt}
      />

      {/* <CardContent className="Card__content">
        <h4 className="headingH4">{props.heading}</h4>

        <Typography paragraph classes={{ root: classes.MuiTypographyRoot }}>
          {props.content}
        </Typography>

        <Button>Know More</Button>
      </CardContent> */}
    </Card>
  );
};

export default withStyles(styles)(CardComponent);